export type ProfileAlignmentTier = 'strong' | 'review' | 'at_risk';

export const getProfileAlignmentTier = (score: number | null | undefined): ProfileAlignmentTier | null => {
  if (score == null || Number.isNaN(score)) {
    return null;
  }

  if (score >= 80) {
    return 'strong';
  }

  if (score >= 60) {
    return 'review';
  }

  return 'at_risk';
};
